import { Component, ChangeDetectionStrategy, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Sale } from '../../../../models/sale/sale.model';
import { Client } from '../../../../models/client/client.model';
import { Lineitem } from '../../../../models/line-item/line-item.model';
import { List } from 'immutable';
import { LineitemsPopoverPage } from '../../lineitems-popover/lineitems-popover.page';
import { SalonMonsterCurrencyPipe } from '../../../../pipes/salonmonster-currency.pipe';

@Component({
  selector: 'smr-sale-client',
  templateUrl: './sale-client.component.html',
  styleUrls: ['./sale-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SalonMonsterCurrencyPipe],
})
export class SaleClientComponent implements OnInit, OnChanges {

  @Input() client: Client;

  @Input() sale: Sale;

  @Input() readOnly: boolean;

  @Output() productAdd = new EventEmitter<Client>();

  @Output() serviceAdd = new EventEmitter<Client>();

  @Output() lineitemSelect = new EventEmitter<Lineitem>();

  public clientLineitems: List<Lineitem>

  public init: boolean;

  constructor (private popoverCtrl: PopoverController,
    private salonMonsterCurrency: SalonMonsterCurrencyPipe) {
   
  }

  public ngOnInit () {
    this.init = true;
    this.filterClientLineitems();
  }

  public ngOnChanges () {
    if (!this.init) {
      return;
    }

    this.filterClientLineitems();
  }

  public filterClientLineitems () {
    this.clientLineitems = this.sale.lineitems.filter(lineitem => lineitem.client && lineitem.client.id === this.client.id).toList();
  }

  public addProductClickHandler () {
    this.productAdd.emit(this.client);
  }

  public addServiceClickHandler () {
    this.serviceAdd.emit(this.client);
  }

  public lineitemClickHandler (lineitem: Lineitem) {
    this.lineitemSelect.emit(lineitem);
  }

  public async addItems ($event) {
    const popOver = await this.popoverCtrl.create({
      component: LineitemsPopoverPage, 
      componentProps:{client: this.client},
      event:$event,
    });
    await popOver.present();
    popOver.onWillDismiss().then((event) => {
      if (event) {
        if (event.data === 'product') {
          this.addProductClickHandler();
        } else if (event.data === 'service') {
          this.addServiceClickHandler();
        }
      }
    });

    return await popOver.present();
  }

}
